<template>
  <section>
    <IHeader />
    <main>
      <keep-alive :include="include">
        <router-view :key="$route.path"></router-view>
      </keep-alive>
    </main>
    <IFooter />
  </section>
</template>

<script>
import IHeader from "@/components/base/Header";
import IFooter from "@/components/base/Footer";
export default {
  props: {},
  data() {
    return {
      activePath: "",
      include: [],
    };
  },
  mounted() {
    this.activePath = this.$route.path;
  },
  computed: {
  },
  components: { IHeader, IFooter },
  methods: {
    handleSelect(val) {
      this.activePath = val;
      this.$router.push(val);
    },
    isIncludesPath(path) {
      return path.indexOf(this.activePath) > -1;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
main {
  min-height: calc(100vh - 190px);
}
</style>
